import styled from 'styled-components';

export const Certificate = styled.img`
  width: 72px;
  height: 72px;
  box-shadow: 0 1px 1px 0 #00000029;
  border-radius: 50%;
`;

export const CertName = styled.p`
  font-size: ${(props) => (props.companion ? '14px' : '14px')};
  color: rgb(0 0 0 / 54%);
  text-align: center;
  padding: ${(props) => (props.companion ? '4px 20px' : '4px 0')};

  @media (max-width: 720px) {
    font-size: ${(props) =>
      props.companion ? '13px' : props.landing ? '14px' : '14px'};
    font-weight: 500;
  }
`;

export const Visitstore = styled.div`
  display: inline-block;
  background: white;
  border-radius: 41px;
  width: 200px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  margin-top: ${(props) => (props.landing ? '1em' : '2em')};
  margin-bottom: ${(props) => (props.landing ? '12px' : '0')};
  font-size: 18px;
  font-weight: 500;
  color: #ef4e5e;
  box-shadow: 0 1px 2px 0 #00000029;
  cursor: pointer;

  @media (max-width: 720px) {
    cursor: default;
    margin-bottom: ${(props) => (props.landing ? '2em' : '0')};
  }
`;

export const Wave = styled.img`
  display: inline-block;
  width: 100%;
  position: absolute;
  bottom: ${(props) => (props.bottom ? props.bottom : '-32px')};
  left: 0;
`;
